/* eslint-disable @nx/enforce-module-boundaries */
import { useTranslation } from '@axo/shared/i18n';
import { Button } from '@axo/ui-core/components/Button';
import { Message } from '@axo/ui-core/components/Message';
import { useState } from 'react';
import styles from './ESkat.module.scss';
import { ESkatDetails } from './ESkatDetails';
import { useESkat } from './hooks/useESkat';

export const ESkatLoggedIn = () => {
  const { t } = useTranslation();

  const [showESkatDetails, setShowESkatDetails] = useState(false);

  const { eSkatData } = useESkat();

  if (!eSkatData) {
    return (
      <Message variant="error" hasIcon>
        {t('ESkat.data_shared_empty')}
      </Message>
    );
  }

  return (
    <>
      <Message variant="success" hasIcon>
        {t('ESkat.data_shared')}

        <Message.Action>
          <Button
            size="small"
            variant="ghost"
            onClick={() => setShowESkatDetails(true)}
            className={styles.detailsButtonOverride}
            data-testid="eskat-details-button"
          >
            {t('ESkat.data_button')}
          </Button>
        </Message.Action>
      </Message>

      <ESkatDetails
        open={showESkatDetails}
        onClose={() => setShowESkatDetails(false)}
      />
    </>
  );
};
